<div class="settingSidebar" [ngClass]="isOpenSidebar ? 'showSettingPanel' : ''">
  <button aria-label="setting" mat-flat-button class="settingPanelToggle link-button" (click)="toggleRightSidebar()"
    target="_blank">
    <app-feather-icons class='link-icon' [icon]="'settings'" [class]="'setting-sidebar-icon'"></app-feather-icons>
  </button>
  <ng-scrollbar [style.height]="maxHeight + 'px'" visibility="hover">
    <div class="settingSidebar-body ps-container ps-theme-default">
      <div class=" fade show active">
        <div class="setting-panel-header">{{'SETTINGS.RIGHT_PANEL.SETTING_PANEL' |
          translate}}
        </div>
        <div class="rightSetting setting-panel-body">
          <h6 class="font-medium m-b-10">{{'SETTINGS.RIGHT_PANEL.SIDE_MENU_COLOR' |
            translate}}</h6>
          <mat-button-toggle-group class="mt-2" [value]="isDarkSidebar ? 'dark' : 'light'">
            <mat-button-toggle (click)="lightSidebarBtnClick()" value="light">{{'SETTINGS.RIGHT_PANEL.LIGHT' |
              translate}}</mat-button-toggle>
            <mat-button-toggle (click)="darkSidebarBtnClick()" value="dark">{{'SETTINGS.RIGHT_PANEL.DARK' |
              translate}}</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
        <div class="p-15 setting-panel-body">
          <h6 class="font-medium m-b-10">{{'SETTINGS.RIGHT_PANEL.COLOR_THEME' |
            translate}}</h6>
          <div class="theme-setting-options">
            <ul class="choose-theme list-unstyled mb-0">
              <li data-theme="white" [ngClass]="{'active': selectedBgColor === 'white'}" (click)="selectTheme('white')">
                <div class="white"></div>
              </li>
              <!-- <li data-theme="black" [ngClass]="{'active': selectedBgColor === 'black'}" (click)="selectTheme('black')">
                <div class="black"></div>
              </li> -->
              <li data-theme="purple" [ngClass]="{'active': selectedBgColor === 'purple'}"
                (click)="selectTheme('purple')">
                <div class="purple"></div>
              </li>
              <li data-theme="orange" [ngClass]="{'active': selectedBgColor === 'orange'}"
                (click)="selectTheme('orange')">
                <div class="orange"></div>
              </li>
              <li data-theme="cyan" [ngClass]="{'active': selectedBgColor === 'cyan'}" (click)="selectTheme('cyan')">
                <div class="cyan"></div>
              </li>
              <li data-theme="green" [ngClass]="{'active': selectedBgColor === 'green'}" (click)="selectTheme('green')">
                <div class="green"></div>
              </li>
              <li data-theme="blue" [ngClass]="{'active': selectedBgColor === 'blue'}" (click)="selectTheme('blue')">
                <div class="blue"></div>
              </li>
            </ul>
          </div>
        </div>
        <!-- <div class="rightSetting">
          <h6 class="font-medium m-b-10">RTL Layout</h6>
          <mat-slide-toggle class="mt-2" [checked]="isRtl" (change)="switchDirection($event)"></mat-slide-toggle>
        </div> -->
      </div>
    </div>
  </ng-scrollbar>
</div>